<script setup lang="ts">
import { computed } from "vue";
import type { UserSegment } from "@/views/power/components/VipPackageActivity/types";
import Promotion618ModalShell from "./Promotion618ModalShell.vue";
import { PROMOTION_618_MODAL_IMAGES } from "./constants";

const modalId = "promotion-618-new-or-expired-modal";
defineOptions({ modalId });

interface Props {
  segment: Extract<UserSegment, "neverPaid" | "expired">;
  onClose?: () => void;
}

const props = defineProps<Props>();

const imageUrl = computed(() => {
  return PROMOTION_618_MODAL_IMAGES[props.segment] ?? PROMOTION_618_MODAL_IMAGES.neverPaid!;
});
</script>

<template>
  <Promotion618ModalShell
    :modal-id="modalId"
    :image-url="imageUrl"
    popup-name="new_or_expired"
    :on-close="onClose"
  />
</template>
